import React, {useState} from 'react';
import emailjs from 'emailjs-com';
import { useAlert } from "react-alert";
import ContactItem from './ContactItem';


const data = [
    {title: 'Call Me', subTitle: '+94-7700-48000', icon: 'uil uil-phone contact__icon'},
    {title: 'Email', subTitle: 'mshafnas125@gmail.com', icon: 'uil uil-envelope contact__icon'},
    {title: 'WhatsApp', subTitle: '+94-7700-48000', icon: 'uil uil-whatsapp contact__icon'},
];

const Contact = () => {
    const alert = useAlert();
    const [isLoading, setLoading] = useState(false);

    function sendEmail(e) {
        e.preventDefault();
        setLoading(true);
        emailjs.sendForm('service_d4zbi7i', 'template_p7xsytb', e.target, 'user_HidN2H3qrpZF1zdrd1Ni7')
        .then((result) => {
            console.log(result);
            if (result.text === 'OK') {
                setLoading(false);
                e.target.reset();
                alert.success("Thanks for contacting me. I will reach to you soon....");
            }
            console.log(result.text);
        }, (error) => {
            setLoading(false);
            e.target.reset();
            console.log(error.text);
        });
    }

    return (
        <section className="contact section" id="contact">
            <h2 className="section__title">Contact Me</h2>
            <span className="section__subtitle">Get in touch</span>
            <div className="contact__container container grid">
                <div>
                {
                    data.map((item, idx) => (
                        <ContactItem key={idx} value={item}/>
                    ))
                }
                </div>
                <div>
                <form onSubmit={sendEmail} className='contact__form grid'>
                    <div className='contact__inputs grid'>
                        <div className='contact__content'>
                            <label className='contact__label'>Name</label>
                            <input type="text" name="name" className="contact__input" placeholder="Enter your name..." required/>
                        </div>
                        <div className='contact__content'>
                            <label className='contact__label'>Email</label>
                            <input type="email" name="email" className="contact__input" placeholder="Enter your email address..." required/>
                        </div>
                        <div className='contact__content'>
                            <label className='contact__label'>Message</label>
                            <textarea cols="30" rows="10" name="message" className="contact__input" placeholder="Write your message..." required></textarea>
                        </div>
                    </div>
        
                    <div className="form-group mt-2">
                        {!isLoading && <button type='submit' className="button button__flex contact__button">Send Message <i className="uil uil-message"></i></button>}
                        {isLoading && <button type='button' className="button button__flex contact__button" disabled>Sending... <i className="uil uil-spinner-alt"></i></button>}
                    </div>
                </form>
                </div>
            </div>
        </section>
    )
}

export default Contact;